import styled from "styled-components";

export const PolaroidContainerWrapper = styled.div`
  margin: 30px auto;
  padding: 0;
  /* justify-content: center;
  align-items: center; */
  position: relative;
  z-index: 99;
`;